<template>
    <AppLayout title="Penyusunan Dokumen Pemilihan !">
        <Toast />
        <div class="relative">
            <div class="py-4" :class="{ 'pointer-events-none': loading }">
                <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                    <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                        <section class="text-gray-600 body-font">
                            <div class="container px-5 py-5 mx-auto">
                                <div class="flex flex-wrap w-full mb-5 flex-col">
                                    <Accordion
                                        :multiple="true"
                                        :activeIndex="[0, 1, 2, 3, 4]"
                                    >
                                        <AccordionTab>
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">Status !</span>
                                                </span>
                                            </template>
                                            <StatusDokumenPengadaanInfo
                                                :status="dataViewDokumenPengadaan.status"
                                            />
                                        </AccordionTab>
                                        <AccordionTab>
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">Data Utama</span>
                                                </span>
                                            </template>
                                            <ViewAttribute
                                                :dataViewDokumenPengadaan="dataViewDokumenPengadaan"
                                            />
                                            <MetodePenyampaianForm
                                                v-model:metode="form.attribute.metode_penyampaian"
                                                v-model:bobot-teknis="form.attribute.bobot_teknis"
                                                v-model:bobot-harga="form.attribute.bobot_harga"
                                                v-model:bobot-keseluruhan="form.attribute.bobot_keseluruhan"
                                                v-model:bobot-kualifikasi="form.attribute.bobot_kualifikasi"
                                            />
                                        </AccordionTab>
                                        <AccordionTab>
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">Penyedia</span>
                                                    <span v-if="form.penyedia.length === 0" class="text-yellow-500 text-sm ml-2">
                                                        (Semua penyedia bisa mendaftar)
                                                    </span>
                                                </span>
                                            </template>
                                            <div v-if="form.penyedia.length === 0 && tenders" class="mb-4 p-4 bg-yellow-50 border-l-4 border-yellow-500 text-yellow-700">
                                                <div class="flex">
                                                    <div class="flex-shrink-0">
                                                        <i class="pi pi-exclamation-triangle mr-2"></i>
                                                    </div>
                                                    <div>
                                                        <p class="font-medium">Perhatian!</p>
                                                        <p>Semua penyedia akan bisa mendaftar karena tidak ada penyedia yang dipilih.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <SelectPenyedia
                                                v-model:list_penyedia="form.penyedia"
                                                :jenis_pekerjaan_id="dataViewDokumenPengadaan.paket_pengadaan.jenis_pengadaan || null" :tender="tenders"
                                            />
                                        </AccordionTab>
                                        <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('dokumen_pengadaan_file')">
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">File</span>
                                                </span>
                                            </template>
                                            <FileDisplay
                                                :existing_files="dataViewDokumenPengadaan.dokumen_pengadaan_file"
                                            />
                                        </AccordionTab>
                                        <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('dokumen_pengadaan_file') && (isPpk || isPokjaPP)">
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">Dokumen Pemilihan</span>
                                                </span>
                                            </template>
                                            <div v-if="dataViewDokumenPengadaan.dokumen_pemilihan_file.length > 0 && isPpk">
                                                <FileDisplay
                                                    :existing_files="dataViewDokumenPengadaan.dokumen_pemilihan_file"
                                                />
                                            </div>
                                            <div v-if="isPokjaPP">
                                                <div class="mb-3 p-3 border-l-4 border-blue-500 bg-blue-50">
                                                    <div class="flex items-center">
                                                        <i class="pi pi-info-circle text-blue-600 mr-2"></i>
                                                        <span class="text-blue-700">Ukuran maksimal file: <strong>10 MB</strong></span>
                                                    </div>
                                                </div>
                                                <FileInput :file_uploads="form.file_uploads" :exlude_hps="true" :required="true" />
                                            </div>
                                        </AccordionTab>
                                        <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('detail_hps')">
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">Detail HPS</span>
                                                </span>
                                            </template>
                                            <DisplayHps
                                                :detail_hps="dataViewDokumenPengadaan.detail_hps"
                                            />
                                        </AccordionTab>
                                        <AccordionTab v-if="dataViewDokumenPengadaan.config.includes('jadwal')">
                                            <template #header>
                                                <span class="flex align-items-center gap-2 w-full">
                                                    <span class="font-bold white-space-nowrap">Jadwal</span>
                                                </span>
                                            </template>
                                            <JadwalInput
                                                v-model:jadwals="form.jadwal"
                                                @jadwal-constraint-valid="onJadwalConstraintValid"
                                            />
                                        </AccordionTab>
                                    </Accordion>
                                    <div v-if="!allow_bypass_jadwal_constraint && !jadwalConstraintValid" class="mb-2 p-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 rounded">
                                        <i class="pi pi-exclamation-triangle mr-2"></i>
                                        Terdapat jadwal yang melanggar aturan. Mohon perbaiki jadwal terlebih dahulu.
                                    </div>
                                    <div class="flex justify-content-end mt-4 gap-2">
                                        <div style="flex: 1"></div>
                                        <Button 
                                            v-if="showVerifikasiUlangButton"
                                            icon="pi pi-refresh"
                                            label="Verifikasi Ulang"
                                            @click="verifikasiUlang"
                                            :loading="loadingVerifikasiUlang"
                                            class="p-button-warning" />
                                        <Button 
                                            icon="pi pi-save"
                                            label="Simpan"
                                            @click="initiateSubmit"
                                            class="p-button-primary" />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <div v-if="loading" class="loading-overlay">
                <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="3" />
                <div class="loading-text">Memproses...</div>
            </div>
        </div>

        <Dialog 
            v-model:visible="showConfirmDialog" 
            :modal="true"
            :closable="false"
            header="Konfirmasi Simpan">
            <div class="p-4">
                <p>Apakah Anda yakin ingin menyimpan dokumen ini?</p>
                <div v-if="form.penyedia.length === 0 && dataViewDokumenPengadaan.paket_pengadaan.metode_pemilihan !=1" class="mt-2 text-yellow-600">
                    <i class="pi pi-info-circle mr-2"></i>
                    <span>Semua penyedia akan bisa mendaftar karena tidak ada penyedia yang dipilih.</span>
                </div>
                <div v-if="form.file_uploads[0].new_file.length === 0 && isPokjaPP" class="mt-2 text-yellow-600">
                    <i class="pi pi-info-circle mr-2"></i>
                    <span>File Dokumen pemilihan belum diinputkan   </span>
                </div>
                <div class="mt-4">
                    <p v-if="cooldownActive" class="text-sm text-gray-500">
                        Mohon tunggu {{ currentCountdown }} detik sebelum konfirmasi...
                    </p>
                </div>
            </div>
            <template #footer>
                <Button 
                    label="Batal" 
                    @click="cancelSubmit" 
                    class="p-button-text" />
                <Button 
                    label="Simpan"
                    @click="confirmSubmit"
                    :disabled="cooldownActive"
                    class="p-button-primary" />
            </template>
        </Dialog>

        <Dialog 
            v-model:visible="showVerifikasiUlangDialog" 
            :modal="true"
            :closable="false"
            header="Konfirmasi Verifikasi Ulang">
            <div class="p-4">
                <p>Apakah Anda yakin ingin melakukan verifikasi ulang?</p>
                <div class="mt-2 text-orange-600">
                    <i class="pi pi-exclamation-triangle mr-2"></i>
                    <span>Dokumen akan dipindahkan ke tahap verifikasi dokumen pengadaan.</span>
                </div>
                <div class="mt-4">
                    <p v-if="verifikasiUlangCooldownActive" class="text-sm text-gray-500">
                        Mohon tunggu {{ verifikasiUlangCountdown }} detik sebelum konfirmasi...
                    </p>
                </div>
            </div>
            <template #footer>
                <Button 
                    label="Batal" 
                    @click="cancelVerifikasiUlang" 
                    class="p-button-text" />
                <Button 
                    label="Verifikasi Ulang"
                    @click="confirmVerifikasiUlang"
                    :disabled="verifikasiUlangCooldownActive"
                    class="p-button-warning" />
            </template>
        </Dialog>
    </AppLayout>
</template>

<script>
import { reactive, ref, getCurrentInstance, onBeforeUnmount } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import StatusDokumenPengadaanInfo from "@/Components/StatusDokumenPengadaanInfo";
import FileDisplay from "./partials/FileDisplay.vue";
import ViewAttribute from "./partials/ViewAttribute.vue";
import DisplayHps from "./partials/DisplayHps.vue";
import JadwalInput from "./partials/JadwalInput.vue";
import MetodePenyampaianForm from "./partials/MetodePenyampaianForm.vue";
import SelectPenyedia from "./partials/SelectPenyedia.vue";
import { Inertia } from '@inertiajs/inertia';
import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";
import ProgressSpinner from 'primevue/progressspinner';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import FileInput from "./partials/FileInput.vue";
import axios from 'axios';

export default {
    components: {
        AppLayout,
        Accordion,
        AccordionTab,
        StatusDokumenPengadaanInfo,
        FileDisplay,
        ViewAttribute,
        DisplayHps,
        JadwalInput,
        MetodePenyampaianForm,
        SelectPenyedia,
        Toast,
        ProgressSpinner,
        Dialog,
        Button,
        FileInput
    },
    props: {
        dataViewDokumenPengadaan: Object,
        file_input_pemilihan: Array,
        errors: Object,
        back_url_param: Object,
    },
    computed: {
        isPokjaPP() {
            const role = this.$page.props.session_role.role_display_name
            return ['pokja','pp'].includes(role)
        },
        isPpk() {
            const role = this.$page.props.session_role.role_display_name
            return ['ppk'].includes(role)
        },
        showVerifikasiUlangButton() {
            // Check if user is pokja
            const role = this.$page.props.session_role?.role_display_name;
            if (!['pokja','pp'].includes(role)) {
                return false;
            }

            // Check if document is in the correct stage
            if (this.dataViewDokumenPengadaan.kode_tahap !== 'penyusunan_dokumen_pemilihan_1f') return false;

            return true;
        },
    },
    setup(props) {
        const toast = useToast();
        const loading = ref(false);
        const loadingVerifikasiUlang = ref(false);
        const showConfirmDialog = ref(false);
        const showVerifikasiUlangDialog = ref(false);
        const cooldownActive = ref(false);
        const verifikasiUlangCooldownActive = ref(false);
        const currentCountdown = ref(3);
        const verifikasiUlangCountdown = ref(5);
        const pendingAction = ref(null);
        const vm = getCurrentInstance().proxy;
        const tenders = ref(false)
        
        // Axios cancel token for request cancellation
        let cancelTokenSource = null;

        // Constraint jadwal
        // Variabel ini hanya bisa diubah lewat script, bukan oleh user di UI.
        // Ubah nilainya di sini sesuai kebutuhan Anda:
        const allow_bypass_jadwal_constraint = ref(false); // ubah ke false jika ingin submit dicegah saat constraint tidak valid
        // Status validasi constraint jadwal dari JadwalInput
        const jadwalConstraintValid = ref(true);

        // Set is_tender based on metode_pemilihan
        tenders.value = props.dataViewDokumenPengadaan.paket_pengadaan.metode_pemilihan !== 1;

        const form = reactive({
            attribute: {
                metode_penyampaian: props.dataViewDokumenPengadaan.paket_pengadaan.jenis_pengadaan === 3 ? '2f' : '1f',
                bobot_teknis: 0,
                bobot_harga: 0,
                bobot_keseluruhan: 50,
                bobot_kualifikasi: 50,
            },
            jadwal: [],
            penyedia: props.dataViewDokumenPengadaan.penyedia || [],
            file_uploads: [],
        });

        // Handler untuk event validasi constraint jadwal dari JadwalInput
        const onJadwalConstraintValid = (isValid) => {
            jadwalConstraintValid.value = isValid;
        };

        // Timer references for cleanup
        let verifikasiUlangTimer = null;
        let confirmTimer = null;

        const verifikasiUlang = () => {
            showVerifikasiUlangDialog.value = true;
            verifikasiUlangCooldownActive.value = true;
            verifikasiUlangCountdown.value = 5;
            
            // Clear existing timer if any
            if (verifikasiUlangTimer) {
                clearInterval(verifikasiUlangTimer);
            }
            
            verifikasiUlangTimer = setInterval(() => {
                verifikasiUlangCountdown.value--;
                if (verifikasiUlangCountdown.value <= 0) {
                    clearInterval(verifikasiUlangTimer);
                    verifikasiUlangTimer = null;
                    verifikasiUlangCooldownActive.value = false;
                }
            }, 1000);
        };

        const confirmVerifikasiUlang = async () => {
            if (!verifikasiUlangCooldownActive.value) {
                showVerifikasiUlangDialog.value = false;
                loadingVerifikasiUlang.value = true;
                
                // Cancel previous request if exists
                if (cancelTokenSource) {
                    cancelTokenSource.cancel('New request initiated');
                }
                
                // Create new cancel token
                cancelTokenSource = axios.CancelToken.source();
                
                try {
                    const response = await axios.post("/dokumen_pengadaan/verifikasi_ulang", {
                        uuid: props.dataViewDokumenPengadaan.uuid,
                    }, {
                        cancelToken: cancelTokenSource.token
                    });

                    if (response.data.success) {
                        // Show success message
                        toast.add({ 
                            severity: 'success', 
                            summary: 'Berhasil!', 
                            detail: response.data.message, 
                            life: 3000 
                        });
                        
                        // Redirect to the appropriate page
                        if (props.back_url_param) {
                            Inertia.visit(route('dokumen_pengadaan.list_dokumen_pengadaan', props.back_url_param));
                        } else {
                            Inertia.visit(route('dokumen_pengadaan.dashboard'));
                        }
                    } else {
                        toast.add({ 
                            severity: 'error', 
                            summary: 'Gagal!', 
                            detail: response.data.message, 
                            life: 3000 
                        });
                    }
                } catch (error) {
                    if (!axios.isCancel(error)) {
                        console.error('Error in verifikasiUlang:', error);
                        const message = error.response?.data?.message || 'Terjadi kesalahan saat melakukan verifikasi ulang';
                        toast.add({ 
                            severity: 'error', 
                            summary: 'Gagal!', 
                            detail: message, 
                            life: 3000 
                        });
                    }
                } finally {
                    loadingVerifikasiUlang.value = false;
                }
            }
        };

        const cancelVerifikasiUlang = () => {
            showVerifikasiUlangDialog.value = false;
            verifikasiUlangCooldownActive.value = false;
            verifikasiUlangCountdown.value = 5;
            
            // Clear timer
            if (verifikasiUlangTimer) {
                clearInterval(verifikasiUlangTimer);
                verifikasiUlangTimer = null;
            }
        };

        const initiateSubmit = () => {
            // Jika allow_bypass_jadwal_constraint = false dan constraint tidak valid, cegah submit
            if (!allow_bypass_jadwal_constraint.value && !jadwalConstraintValid.value) {
                toast.add({
                    severity: "warn",
                    summary: "Peringatan Jadwal",
                    detail: "Terdapat jadwal yang melanggar aturan. Mohon perbaiki jadwal terlebih dahulu.",
                    life: 7000,
                    closable: false,
                    styleClass: "bg-yellow-100 text-yellow-900 border-yellow-200"
                });
                return;
            }
            showConfirmDialog.value = true;
            cooldownActive.value = true;
            currentCountdown.value = 3;
            
            // Clear existing timer if any
            if (confirmTimer) {
                clearInterval(confirmTimer);
            }
            
            confirmTimer = setInterval(() => {
                currentCountdown.value--;
                if (currentCountdown.value <= 0) {
                    clearInterval(confirmTimer);
                    confirmTimer = null;
                    if (vm.isPokjaPP && form.file_uploads[0].new_file.length === 0) {
                        toast.add({
                            severity: "warn",
                            summary: "Perhatian",
                            detail: "Silakan pilih file dokumen pemilihan terlebih dahulu.",
                            life: 7000,
                            closable: false,
                            styleClass: "bg-yellow-100 text-yellow-900 border-yellow-200"
                        });
                    } else {
                        cooldownActive.value = false;
                    }
                }
            }, 1000);
        };

        const confirmSubmit = () => {
            if (!cooldownActive.value) {
                showConfirmDialog.value = false;
                submit();
            }
        };

        const cancelSubmit = () => {
            showConfirmDialog.value = false;
            cooldownActive.value = false;
            currentCountdown.value = 3;
            
            // Clear timer
            if (confirmTimer) {
                clearInterval(confirmTimer);
                confirmTimer = null;
            }
        };

        const submit = () => {
            loading.value = true;
            
            if (form.penyedia.length === 0 && props.dataViewDokumenPengadaan.paket_pengadaan.metode_pemilihan != 1) {
                toast.add({
                    severity: "warn",
                    summary: "Perhatian",
                    detail: "Semua penyedia akan bisa mendaftar karena tidak ada penyedia yang dipilih",
                    life: 7000,
                    closable: false,
                    styleClass: "bg-yellow-100 text-yellow-900 border-yellow-200"
                });
            }

            Inertia.post(route("dokumen_pengadaan.action_penyusunan_dokumen_pemilihan"), {
                uuid: props.dataViewDokumenPengadaan.uuid,
                attribute: form.attribute,
                jadwal: form.jadwal,
                file_uploads: form.file_uploads,
                penyedia: form.penyedia,
                back_url_param: props.back_url_param,
            }, {
                preserveScroll: true,
                onSuccess: (page) => {
                    loading.value = false;
                    if (page.props.flash.error) {
                        toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: page.props.flash.error,
                            life: 5000
                        });
                    } else if (page.props.flash.success) {
                        toast.add({
                            severity: 'success',
                            summary: 'Berhasil',
                            detail: page.props.flash.success,
                            life: 3000
                        });
                    }
                    console.log("back_url_param", props.back_url_param);
                    if (props.back_url_param) {
                        console.log("REDIRECT TO LIST DOKUMEN PENGADAAN");
                        Inertia.visit(route('dokumen_pengadaan.list_dokumen_pengadaan', props.back_url_param));
                    } else {
                        // If back_url_param is not provided, use a default navigation
                        Inertia.visit(route('dokumen_pengadaan.dashboard'));
                    }
                    
                },
                onError: (errors) => {
                    loading.value = false;
                    let errorMessage = 'Terjadi kesalahan saat menyimpan dokumen';
                    
                    // Check for specific validation errors
                    if (errors.attribute) {
                        errorMessage = errors.attribute;
                    } else if (errors.jadwal) {
                        errorMessage = errors.jadwal;
                    } else if (errors.penyedia) {
                        errorMessage = errors.penyedia;
                    }
                    console.log("errorMessageBE", errors);
                    console.log("errorMessage", errorMessage);
                    
                    
                    toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: errorMessage,
                        life: 5000
                    });
                },
                onFinish: () => {
                    loading.value = false;
                }
            });
        };

        // Cleanup on component unmount
        onBeforeUnmount(() => {
            // Clear all timers
            if (verifikasiUlangTimer) {
                clearInterval(verifikasiUlangTimer);
                verifikasiUlangTimer = null;
            }
            if (confirmTimer) {
                clearInterval(confirmTimer);
                confirmTimer = null;
            }
            
            // Cancel any pending axios requests
            if (cancelTokenSource) {
                cancelTokenSource.cancel('Component unmounted');
                cancelTokenSource = null;
            }
        });

        return {
            form,
            loading,
            loadingVerifikasiUlang,
            showConfirmDialog,
            showVerifikasiUlangDialog,
            cooldownActive,
            verifikasiUlangCooldownActive,
            currentCountdown,
            verifikasiUlangCountdown,
            initiateSubmit,
            confirmSubmit,
            cancelSubmit,
            submit,
            verifikasiUlang,
            confirmVerifikasiUlang,
            cancelVerifikasiUlang,
            tenders,
            allow_bypass_jadwal_constraint, // expose ke template
            jadwalConstraintValid,
            onJadwalConstraintValid,
        };
    },
    mounted() {
        console.log("PenyusunanDokumenPemilihan mounted", this.dataViewDokumenPengadaan);
        console.log("is_tender", this.tenders);
        
        // Add safety check to prevent infinite loops
        if (!this.dataViewDokumenPengadaan) {
            console.error('dataViewDokumenPengadaan is null or undefined');
            return;
        }
        
        if (this.file_input_pemilihan && Array.isArray(this.file_input_pemilihan) && this.isPokjaPP) {
            this.file_input_pemilihan.forEach((file) => {
                this.form.file_uploads.push({
                    id_file_dokumen_pengadaan: file.id,
                    id_jadwal_pengadaan: file.id_jadwal_pengadaan,
                    id_dokumen_pengadaan: file.id_dokumen_pengadaan,
                    id_file_dokumen_prosedur: file.id_file_dokumen_prosedur,
                    kode_file: file.kode_file,
                    kode_prosedur: file.kode_prosedur,
                    nama_file: file.nama_file,
                    file_path: file.file_path,
                    file_type: file.file_type,
                    file_dokumen_type: file.file_dokumen_type,
                    file_dokumen_type_id: file.file_dokumen_type_id,
                    multiple: file.is_multiple === 1,
                    new_file: [],
                });
            });
        } 
        
        // Initialize jadwal from dataViewDokumenPengadaan if available
        if (this.dataViewDokumenPengadaan?.jadwal) {
            // Initialize jadwal with empty/null dates
            this.form.jadwal = this.dataViewDokumenPengadaan.jadwal.map((jadwal, index) => {
                return {
                    ...jadwal,
                    existing_jadwal: {
                        waktu_mulai: null,
                        waktu_selesai: null,
                        keterangan: jadwal.existing_jadwal?.keterangan || ''
                    }
                };
            });
        }
    },
};
</script>

<style scoped>
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 50;
}

.loading-text {
    margin-top: 1rem;
    color: var(--primary-color);
    font-size: 1rem;
    font-weight: 500;
}

.pointer-events-none {
    pointer-events: none;
    opacity: 0.7;
}

:deep(.p-toast-message-warn) {
    background-color: #fef3c7 !important;
    border: solid #fcd34d;
    border-width: 0 0 0 6px;
    color: #92400e !important;
}

:deep(.p-toast-message-warn .p-toast-message-icon),
:deep(.p-toast-message-warn .p-toast-icon-close) {
    color: #92400e !important;
}
</style>